import cx from 'classnames';
import { Image } from 'components/Image/Image';
import { TextV2 } from 'components/TextV2/TextV2';
import backButton from 'images/icons/back-arrow.svg';
import { useHistory } from 'react-router-dom';
import styles from './CheckoutBasePage.module.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LinkVariant } from 'api/contentful/contentTypes.cloverdotcom';
import { Grid } from 'components/Grid/Grid';
import { GridContainer } from 'components/GridContainer/GridContainer';
import { StructuredModal } from 'components/StructuredModal/StructuredModal';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { CheckoutLoading } from '../CheckoutLoading/CheckoutLoading';
import { useCheckout } from '../CheckoutProvider';
import { defaultErrorState } from '../Utils';

interface ICheckoutBasePageProps {
  children: React.ReactNode;
  isBackButtonVisible?: boolean;
}

export const CheckoutBasePage: React.FC<ICheckoutBasePageProps> = ({ children, isBackButtonVisible }) => {
  const { t } = useTranslation();
  const { isLoading, errorState, setErrorState, hasApplicationError, setHasApplicationError } = useCheckout();
  const { browser } = useBreakpoints();
  const isDesktopOrLarge = browser.is.desktop;
  const history = useHistory();

  const onBackButtonClick = () => {
    history.goBack();
  };

  const { hasApiError } = errorState;

  const setHasApiError = (value: boolean) => {
    setErrorState({
      ...defaultErrorState,
      hasApiError: value,
    });
  };

  return (
    <main className={styles.pageContainer}>
      {isBackButtonVisible && (
        <button className={styles.backButton} onClick={onBackButtonClick}>
          <Image src={backButton} aria-hidden />
          <TextV2 tagName="p" variant="body" value={t('back')} />
        </button>
      )}
      <div className={cx({ [styles.headingPaddingTop]: !isBackButtonVisible })}>
        <GridContainer gutter justifyContent="center" className={styles.pageContainerContent}>
          <Grid item xs={12} md={9} lg={6} xl={6} className={styles.mainContent}>
            {isLoading ? <CheckoutLoading /> : children}
          </Grid>
        </GridContainer>
      </div>
      <StructuredModal
        modalState={[hasApplicationError, setHasApplicationError]}
        title={t('checkout-error.heading')}
        description={isDesktopOrLarge ? t('checkout-error.body') : t('checkout-error.mobile-body')}
        actions={[
          {
            label: t('checkout-error.cta-label'),
            variant: LinkVariant.SECONDARY,
            isCloseButton: true,
          },
        ]}
      />
      <StructuredModal
        modalState={[hasApiError, setHasApiError]}
        title={t('something-went-wrong-title')}
        description={t('checkout-error.description')}
        actions={[
          {
            label: t('checkout-error.cta-label'),
            variant: LinkVariant.SECONDARY,
            isCloseButton: true,
          },
        ]}
      />
    </main>
  );
};

CheckoutBasePage.displayName = 'CheckoutBasePage';
